import * as React from 'react';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { CardContent, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next';
import { useStyles } from '../common/styles';
import { useAuth0 } from "@auth0/auth0-react";
import { httpHeader, handleFetchErrors, getApiUrl, convertToAuth0Language, checkModuleActive } from '../common/utils';
import { SessionContext } from './../App';
import DOMPurify from 'dompurify';

export default function HRDocumentTile() {
    const QTY_BY_PAGE = 20;
    const { t } = useTranslation();
    const classes = useStyles();
    const { isAuthenticated, getAccessTokenSilently, loginWithRedirect } = useAuth0();
    const [documents, setDocuments] = React.useState([]);
    const SessionContextConsumer = React.useContext(SessionContext);
    const { dispatch, state } = SessionContextConsumer;
    const [query, setQuery] = React.useState({ url: '', pageNo: 0, allLoad: false });
    const [isSearching, setIsSearching] = React.useState(false);

    window.onscroll = () => {
        if (document.documentElement.scrollHeight - (document.documentElement.offsetHeight / 2) <= document.documentElement.scrollTop + document.documentElement.offsetHeight) {
            loadNextPage({ ...query, pageNo: query.pageNo + 1 });
        }
    }

    const loadNextPage = async (newQuery: any) => {
        if (isSearching) return;
        if (newQuery.allLoad) return;

        setQuery(newQuery);
        try {

            setIsSearching(true);
            var httpCmd = {};
            await getAccessTokenSilently({ audience: (window as any).Config.Auth0Audience, scope: 'openid profile email', ignoreCache: false }).then(token => {
                httpCmd = httpHeader('GET', token);
            }).catch(e => console.log(e));

            try {
                var res = await fetch(getApiUrl((window as any).Config, 'hrportal') + '/news?addressid=' + state.AddressId + '&contractid=' + state.ContractId + '&pageno=' + newQuery.pageNo + '&pagesize=' + QTY_BY_PAGE, httpCmd); //'/document?type=general&addressid=' + state.AddressId + '&contractid=' + state.ContractId + '&pageno=' + newQuery.pageNo + '&pagesize=' + QTY_BY_PAGE, httpCmd)

                var text = await handleFetchErrors(res).text();
                //console.log(text);

                if (text.length > 0) {
                    var json = JSON.parse(text);

                    //console.log('before set');
                    if (newQuery.pageNo === 0)
                        setDocuments(json.documents);
                    else
                        setDocuments(documents.concat(json.documents));
                }
                else
                    await setQuery(query => ({ ...query, allLoad: true })); //tout est loadé !
            }
            catch (e) {
                console.log(e);
            }
        }
        finally {
            setIsSearching(false);
        };
    }

    React.useEffect(() => {//when logged in
        if (isAuthenticated && state.AddressId && state.AddressId > 0) {
            loadNextPage(query);
        }
        else
            loginWithRedirect({ ui_locales: convertToAuth0Language(''), redirectUri: window.location.origin + process.env.PUBLIC_URL });
    }, [isAuthenticated, state]);

    if (!checkModuleActive('News')) //Hidden module in config
        return (<></>);

    return (
        <Container maxWidth="md" className={classes.centeredTopContainer}>
            <Card className={classes.card}>
                <CardContent>
                    <Typography><FontAwesomeIcon icon="newspaper" size="2x" fixedWidth className={classes.icons} /><span className={classes.pageTitleText}>{t("News")}</span></Typography>
                    <Divider className={classes.pageTitleDivider}/>
                    {//<Typography variant="h5" className={classes.title}>{t("News")}</Typography>
                        documents.map((news: any) => {
                            if ('title' in news)
                                return (<Grid container style={{ width: '100%' }} key={news.guid} className={classes.tileCard}>
                                    <Grid item xs={10} sm={10} lg={11}><Typography variant="h6">{news.title}</Typography>
                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.content) }}/>
                                    </Grid>
                                </Grid>);
                            else
                                return null;
                        })
                    }
                    {(document.documentElement.scrollHeight - 50 <= document.documentElement.clientHeight) && !query.allLoad && documents.length % QTY_BY_PAGE === 0 && (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><Button variant="contained" color="default" size="medium" onClick={() => { loadNextPage({ ...query, pageNo: query.pageNo + 1 }); }}>
                            {t("Loading")}
                        </Button></div>
                    )}
                </CardContent>
            </Card>
        </Container>
    );
}